export const TRANSLATIONS_PT_SETTINGS_CORE = {
  "settings.db_connection_title": "Conexão ao Banco de Dados",
  "settings.db_tables_title": "Tabelas do Banco de Dados",
  "settings.db_table_name": "Nome da tabela",
  "settings.db_send_selected": "Enviar tabelas selecionadas",
  "settings.db_loading": "Processando conexão...",
  "settings.db_connect_success": "Conexão bem-sucedida ao banco de dados.",
  "settings.db_connect_error": "Erro ao conectar ao banco de dados.",
  "settings.db_not_configured": "As credenciais de conexao com o banco nunca foram configuradas.",
  "settings.db_send_success": "Tabelas enviadas com sucesso.",
  "settings.db_send_error": "Erro ao enviar tabelas.",
  "settings.db_tables_error": "Erro ao obter tabelas.",
  "settings.db_table_connect_success": "Tabela conectada com sucesso.",
  "settings.db_table_connect_error": "Erro ao conectar a tabela.",
  "settings.cancel": "Cancelar",
  "settings.theme": "Tema",
  "settings.language": "Idioma",
  "settings.light": "Claro",
  "settings.dark": "Escuro",
  "settings.spanish": "Espanhol",
  "settings.english": "Inglês",
  "settings.portuguese": "Português",
  "settings.french": "Francês",
  "settings.japanese": "Japonês",
  "settings.title": "Configuração",
  "settings.customization": "Personalização",
  "settings.company_logo": "Logo da Empresa",
  "settings.logo_placeholder": "Envie seu logo aqui",
  "settings.save": "Salvar",
  "settings.save_error": "Erro ao salvar as configurações",
  "settings.db_type": "Tipo de Banco de Dados",
  "settings.db_host": "Host",
  "settings.db_port": "Porta",
  "settings.db_user": "Usuário",
  "settings.db_password": "Senha",
  "settings.db_name": "Banco de Dados",
  "settings.select_db_type": "Selecione...",
  "settings.tab_preferences": "Preferências",
  "settings.tab_bc_email_pooling": "BC Email Pooling",
  "settings.bc_title": "E-mail BC vinculado",
  "settings.bc_create_btn": "Adicionar e-mail BC",
  "settings.bc_update_btn": "Atualizar e-mail BC",
  "settings.bc_create_success": "E-mail BC vinculado com sucesso.",
  "settings.bc_create_error": "Erro ao vincular o e-mail BC.",
  "settings.bc_update_success": "E-mail BC atualizado com sucesso.",
  "settings.bc_update_error": "Erro ao atualizar o e-mail BC.",
  "settings.bc_not_configured": "Nao existe um BC User Binding configurado para este usuario.",
  "settings.whatsapp_not_configured": "Nenhum numero de WhatsApp foi configurado.",
  "settings.tab_email_oauth": "Permissão de e-mail (OAuth)",
  "settings.email_oauth_title": "Permissão de conexão de e-mail (OAuth)",
  "settings.email_oauth_placeholder":
    "Aqui você poderá autorizar o acesso ao seu provedor de e-mail (Gmail, Outlook, etc.) em breve.",
  "settings.tab_advanced": "Avançado",
  "settings.advanced_title": "Configuração Avançada",
  "settings.penalty_questions": "Penalização Perguntas",
  "settings.penalty_none": "Sem penalização",
  "settings.penalty_low": "Penalização baixa",
  "settings.penalty_medium": "Penalização média",
  "settings.penalty_high": "Penalização alta",
  "settings.penalty_questions.tfidf_min": "TF-IDF mínimo",
  "settings.penalty_questions.embedding_min": "Embedding mínimo",
  "settings.penalty_questions.tfidf_penalty": "Penalidade TF-IDF",
  "settings.penalty_questions.save": "Salvar configurações de penalidade",
  "settings.penalty_questions.load_error":
    "Erro ao carregar a configuração de penalidade.",
  "settings.penalty_questions.save_success":
    "Configuração de penalidade salva com sucesso.",
  "settings.penalty_questions.save_error":
    "Erro ao salvar a configuração de penalidade.",
  "settings.penalty_questions.enabled": "Ativar penalidade de perguntas",
  "settings.penalty_questions.header_parameter": " Parâmetros de penalidade",
  "settings.penalty_questions.header_value": " Valor",
  "settings.all_types": "Todos os tipos",
  "settings.select": "Selecionar",
  "settings.edit": "Editar",
  "settings.delete": "Excluir",
  "settings.tables": "Tabelas",
  "settings.search_table": "Buscar tabela",
  "settings.no_tables": "Não há tabelas disponíveis",
  "settings.database": "Banco de Dados",
  "settings.host": "Host",
  "settings.port": "Porta",
  "settings.username": "Usuário",
  "settings.password": "Senha",
  "settings.logo_help": "Envie um logo em PNG ou SVG",
  "settings.logo_error": "Erro ao enviar o logo",
  "settings.close": "Fechar",
  "settings.save_success": "Configurações salvas com sucesso",
  "settings.bc_email_label": "E-mail BC",
  "settings.db_delete_success": "Conexão ao BD excluída com sucesso",
  "settings.db_delete_error": "Erro ao excluir a conexão ao BD",
  "settings.select_tables": "Selecionar tabelas",
  "settings.whatsapp_title": "Configurações do WhatsApp",
  "settings.whatsapp_country_code": "Código do país",
  "settings.whatsapp_country_code_placeholder": "Insira o código do país",
  "settings.whatsapp_country_code_error": "Insira um código de país válido",
  "settings.whatsapp_number": "Número do WhatsApp",
  "settings.whatsapp_number_error": "Número inválido",
  "settings.whatsapp_invalid_number": "Número inválido",
  "settings.whatsapp_invalid_reason_format": "Formato inválido",
  "settings.whatsapp_invalid_reason_possible": "Número não possível para o país selecionado",
  "settings.whatsapp_invalid_reason_valid": "Número inválido",
  "settings.whatsapp_save_btn": "Salvar",
  "settings.whatsapp_save_success": "Número do WhatsApp salvo",
  "settings.whatsapp_save_error": "Erro ao salvar o número do WhatsApp",
  "settings.whatsapp_update_success": "Número do WhatsApp atualizado",
  "settings.whatsapp_update_error": "Erro ao atualizar o número do WhatsApp",
  "settings.whatsapp_delete_btn": "Excluir",
  "settings.whatsapp_delete_success": "Número do WhatsApp excluído",
  "settings.whatsapp_delete_error": "Erro ao excluir o número do WhatsApp",
  "settings.whatsapp_edit_btn": "Editar",
  "settings.whatsapp_configured_number": "Número configurado:",
  "settings.error_required": "Este campo é obrigatório.",
  "settings.tab_google_integrations": "Integrações do Google",
  "settings.tab_microsoft_integrations": "Integracoes Microsoft",
  "settings.reindex.title": "Reindexar documentos",
  "settings.reindex.description": "Reprocessa todos os seus documentos no Home IA e no Knowledge Hub (reclassificação e extração de conhecimento). Use se você alterou suas regras ou quer atualizar a análise. Não reenvia arquivos.",
  "settings.reindex.button": "Reindexar meus documentos",
  "settings.reindex.confirm": "Sim, reindexar",
  "settings.reindex.cancel": "Cancelar",
  "settings.reindex.error": "Não foi possível iniciar a reindexação. Tente novamente.",
  "settings.purge.title": "Excluir todos os meus documentos",
  "settings.purge.description": "Exclui definitivamente todos os seus documentos (incluindo os arquivos), conversas, classificações e dados do Home IA / Knowledge Hub. Também desconecta suas contas do Google e da Microsoft (removendo seus tokens e registros de sincronização), portanto você precisará reconectá-las para sincronizar novamente. O histórico de uso de tokens é preservado. A limpeza é executada em segundo plano e você receberá uma notificação ao final.",
  "settings.purge.button": "Excluir todos os meus documentos",
  "settings.purge.confirm": "Sim, excluir tudo",
  "settings.purge.cancel": "Cancelar",
  "settings.purge.error": "Não foi possível iniciar a limpeza. Tente novamente.",
};
